import type { ReactNode } from 'react'

export function PageHeader({ title, actions }: { kicker: string; title: string; description?: string; actions?: ReactNode }) {
  return <header className="page-header">
    <div><h1>{title}</h1></div>
    {actions && <div className="header-actions">{actions}</div>}
  </header>
}
